module.exports = __webpack_public_path__ + "static/img/BR@3x.e6eed631.jpg";